import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
/* eslint-disable jsx-a11y/anchor-is-valid */
/* global dcAnalytics */

import { signinStatuses } from './constants/signinOverlayConstants.js';
import { onSendPasswordReset, isEmailSent } from './utilities/signinUtilities.js';
import { decodeXml } from '../utils/encodeXML.ts';

export const SigninOverlayMessage = createReactClass({
    propTypes: {
        onReturnToEmailView: PropTypes.func.isRequired,
        showLoadingDots: PropTypes.func.isRequired,
        messages: PropTypes.arrayOf(PropTypes.string),
        errors: PropTypes.arrayOf(PropTypes.string),
        signinStatus: PropTypes.string,
        username: PropTypes.string,
        primaryEmailHint: PropTypes.string,
    },
    getDefaultProps: function () {
        return {
            messages: [],
            errors: [],
        };
    },

    onSendForgotPasswordClick: function (event) {
        this.props.showLoadingDots();
        onSendPasswordReset(event);
    },

    renderAllMessages: function () {
        if (this.props.signinStatus === signinStatuses.FORGOT_PASSWORD_SENT) {
            dcAnalytics.track('Sign in - email sent - forgot password');
            return (
                <div>
                    <h2>Check your email to continue signing in!</h2>
                    <p>We&apos;ve sent an email with a link to reset your password to <strong>{this.props.username}</strong>.</p>
                    <hr />
                    <p>Not your email? <a href='#' onClick={this.props.onReturnToEmailView}>Re-enter your address</a>.</p>
                </div>
            );
        } else if (this.props.signinStatus === signinStatuses.INSTANT_SIGNIN_SENT && this.props.primaryEmailHint) {
            dcAnalytics.track('Sign in - email sent - magic link');
            return (
                <div>
                    <h2>Check your email to continue signing in!</h2>
                    <p>We&apos;ve sent an instant sign-in link to the primary email address on your teacher account, ending in <strong>@{this.props.primaryEmailHint}</strong>.</p>
                    <p>Your primary email is the address you entered during registration, and where you receive all communications from us.</p>
                    <p><a href={secureBaseURL + 'common/contact_landing.html'}>Contact us</a> if you have questions.</p>
                    <hr />
                    <p>Not your email? <a href='#' onClick={this.props.onReturnToEmailView}>Re-enter your address</a>.</p>
                </div>
            );
        } else if (this.props.signinStatus === signinStatuses.INSTANT_SIGNIN_SENT || this.props.signinStatus === signinStatuses.INSTANT_SIGNIN_SENT_TO_TEACHER_SCHOOL_EMAIL) {
            dcAnalytics.track('Sign in - email sent - magic link');
            return (
                <div>
                    <h2>Check your email to continue signing in!</h2>
                    <p>We&apos;ve sent an email with an instant sign-in link to <strong>{this.props.username}</strong>.</p>
                    <hr />
                    <p>Not your email? <a href='#' onClick={this.props.onReturnToEmailView}>Re-enter your address</a>.</p>
                </div>
            );
        } else if (this.props.signinStatus === signinStatuses.TEACHER_CONFIRMATION_SENT) {
            dcAnalytics.track('Sign in - email sent - teacher confirmation');
            return (
                <div>
                    <h2>Check your email to continue signing in!</h2>
                    <p>We&apos;ve sent an email with a confirmation link to <strong>{this.props.username}</strong>.</p>
                    <hr />
                    <p>Not your email? <a href='#' onClick={this.props.onReturnToEmailView}>Re-enter your address</a>.</p>
                </div>
            );
        } else if (this.props.signinStatus === signinStatuses.PRIMARY_EMAIL_AND_PASSWORD_REQUIRED) {
            return (
                <div>
                    <p>You entered your school email, which is not the primary email on your account. Enter your primary email and password to log in.</p>
                    <p>Hint: it&apos;s usually a personal email address, and where you receive all communications from us.</p>
                    <p><a href='#' onClick={this.props.onReturnToEmailView}>Re-enter your address</a> or <a href={secureBaseURL + 'common/contact_landing.html'}>contact us</a> if you have questions.</p>
                </div>
            );
        } else if (this.props.signinStatus === signinStatuses.USERNAME_UNKNOWN) {
            return (
                <div>
                    <p>The email address <strong>{this.props.username}</strong> isn&apos;t associated with a DonorsChoose account.</p>
                    <p><a href='#' onClick={this.props.onReturnToEmailView}>Re-enter your address</a> or <a href={secureBaseURL + 'common/contact_landing.html'}>contact us</a> if you have questions.</p>
                </div>
            );
        } else if (this.props.signinStatus === signinStatuses.PASSWORD_UNKNOWN) {
            return (
                <div>
                    <p>Email address and/or password do not match.</p>
                    <p>Try again or <a href={'#'} onClick={this.onSendForgotPasswordClick}>reset your password</a>.</p>
                </div>
            );
        } else if (this.props.signinStatus === signinStatuses.ACCOUNT_LOCKED) {
            return (
                <div>
                    <p>{this.renderErrors()}</p>
                    <p><a href='#' onClick={this.onSendForgotPasswordClick}>Reset your password</a> to unlock your account.</p>
                </div>
            );
        } else if (this.hasMessages()) {
            return (
                <div>
                    {this.renderMessages()}
                    {this.renderErrors()}
                </div>
            );
        }
        return null;
    },

    renderMessages: function () {
        return this.props.messages.map((message, index) => {
            const decoded = decodeXml(message);
            return (
                <div key={'message' + index} dangerouslySetInnerHTML={{ __html: decoded }} />
            );
        });
    },

    renderErrors: function () {
        return this.props.errors.map((message, index) => {
            const decoded = decodeXml(message);
            return (
                <div key={'error' + index} dangerouslySetInnerHTML={{ __html: decoded }} />
            );
        });
    },

    hasMessages: function () {
        return (this.props.messages.length > 0) || (this.props.errors.length > 0);
    },

    render() {
        const messageClassName = (isEmailSent(this.props.signinStatus)) ? 'overlay-padding' : 'sign-in-error alert-message error';
        const allMessages = this.renderAllMessages();
        if (allMessages != null) {
            return (
                <div className={messageClassName}>
                    {allMessages}
                </div>
            );
        }
        return null;
    },
});
